import { BrnInput } from './lib/brn-input';

export * from './lib/brn-input';

export const BrnInputImports = [BrnInput] as const;
